module.exports = __webpack_public_path__ + "img/scatter-plot-light-01.eb434981.jpg";